import {
  DEFAULT_SHOP_LOCALE,
  inferLocaleFromPathname,
  withLocalePrefix,
} from '../../../../i18n/shopLocale'
import type { RouteContentLoaderLocaleContext } from './types'

/**
 * Resolve route content locale context.
 *
 * Explains routing behavior, guards, and response semantics.
 */
export const resolveRouteContentLocaleContext = (): RouteContentLoaderLocaleContext => {
  const currentLocale = inferLocaleFromPathname(window.location.pathname) ?? DEFAULT_SHOP_LOCALE
  return {
    currentLocale,
    toLocalizedCanonical: (path: string) => withLocalePrefix(path, currentLocale),
  }
}
